import React, { FC, MouseEvent } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Member } from '../../@types/member'
import { Prefix } from '../../@types/prefix'
import { makePath } from '../../helpers/path'
import { useLocation } from 'react-router'
import { useDispatch } from 'react-redux'
import AuthService from '../../services/auth'
import { setUser } from '../../store/user/user.actions'
import { Icon } from '@iconify/react'
import { message } from 'antd'

interface BottomBarProps {
	prefix?: Prefix
	member: Member | undefined
}
const BottomBar: FC<BottomBarProps> = ({ member, prefix }) => {
	const [messageApi, contextHolder] = message.useMessage();
	const history = useHistory()
	const loc = useLocation()
	const dispatch = useDispatch()
	const playgameMotion = prefix?.playgameMotion === "" || prefix?.playgameMotion === "dance" ? "dance" : prefix?.playgameMotion;

	const launchGame = (e: MouseEvent<any>) => {
		e.preventDefault()

		if (!member?.game.meta) {
			// toast.error('กรุณาฝากเงินครั้งแรกเพื่อเข้าเล่นเกม')
			messageApi.open({
				type: 'error',
				content: 'กรุณาฝากเงินครั้งแรกเพื่อเข้าเล่นเกม',
			});
			return
		}
		history.push(makePath('/launch-game'))
	}

	const refetchCredit = async () => {
		try {
			const res = await AuthService.getMemberInfo(true)
			dispatch(setUser(res))
		} catch ({ message }: any) {
			// toast.error(message as string)
			messageApi.open({
				type: 'error',
				content: message as string,
			});
		}
	}

	return (
		<>
			{contextHolder}
			<div className='bottombar-mobile'>
				<div className="bg-bottombar"></div>
				<ul className="nav-menu">
					<li className="nav-item">
						<Link
							to={makePath('/wallet')}
							onClick={() => { refetchCredit() }}
							className={`nav-link ${loc.pathname === '/wallet' && 'active'}`}
						>
							{loc.pathname === '/wallet' ?
								<Icon icon="solar:wallet-bold" width={24} style={{ marginBottom: 4, color: 'var(--color-primary)' }} /> :
								<Icon icon="solar:wallet-linear" width={24} style={{ marginBottom: 4 }} />
							}
							<span>กระเป๋า</span>
						</Link>
					</li>
					<li className="nav-item">
						<Link
							to={makePath('/deposit')}
							className={`nav-link ${(loc.pathname === '/deposit' || loc.pathname === '/deposit/bank') && 'active'}`}
						>
							{loc.pathname === '/deposit' || loc.pathname === '/deposit/bank' ?
								<Icon icon="solar:circle-top-down-bold" width={24} style={{ marginBottom: 4, color: 'var(--color-primary)' }} /> :
								<Icon icon="solar:circle-top-down-linear" width={24} style={{ marginBottom: 4 }} />
							}
							<span>ฝากเงิน</span>
						</Link>
					</li>
					<li className="nav-item middle-item">
						<a href="#game" className={`nav-link ${loc.pathname === '/launch-game' && 'active'}`} onClick={launchGame}>
							<div className={`icon-button-container ${playgameMotion}`}>
								{prefix?.playgameImage ?
									<img className="icon-center" src={prefix?.playgameImage} alt="icon" /> :
									<img className="icon-center" src={`/icons/3d/dice.png`} alt="icon" />
								}
							</div>
							<span>เข้าเล่นเกม</span>
						</a>
					</li>
					<li className="nav-item">
						<Link
							to={makePath('/promotion')}
							className={`nav-link ${loc.pathname === '/promotion' && 'active'}`}
						>
							{loc.pathname === '/promotion' ?
								<Icon icon="ion:gift" width={24} style={{ marginBottom: 4, color: 'var(--color-primary)' }} /> :
								<Icon icon="ion:gift-outline" width={24} style={{ marginBottom: 4 }} />
							}
							<span>โปรโมชั่น</span>
						</Link>
					</li>
					<li className="nav-item">
						<Link
							to={makePath('/profile')}
							className={`nav-link ${loc.pathname === '/profile' && 'active'}`}
						>
							{loc.pathname === '/profile' ?
								<Icon icon="solar:user-bold" width={24} style={{ marginBottom: 4, color: 'var(--color-primary)' }} /> :
								<Icon icon="solar:user-linear" width={24} style={{ marginBottom: 4 }} />
							}
							<span>โปรไฟล์</span>
						</Link>
					</li>
				</ul>
			</div>
		</>
	)
}

export default BottomBar
